export default __webpack_public_path__ + "static/media/dashboard-onboarding-bg.bdeac099.png";